import { Route, Routes, useParams } from 'react-router-dom';

import { useAccident } from '@/hooks/api/use-accidents';
import SmallSpinner from '@/components/shared/spinners/small-spinner';
import DetailSinistre from '@/pages/accident/sinistre/detail-sinistre';
import AjoutReparateur from '@/pages/accident/sinistre/ajout-reparateur';

const Sinistre = () => {
    const { id, ids } = useParams();
    /* Relu à chaque ouverture de la fiche, avec le spinner pendant la lecture, comme auparavant */
    const query = useAccident(id, ids);

    if (query.isError) return <p>Erreur dans le chargement</p>;
    if (query.isFetching || !query.data) return <SmallSpinner />;

    const accident = query.data;

    return (
        <Routes>
            <Route index element={<DetailSinistre accident={accident} />} />
            <Route path={'/ajouter-reparateur'} element={<AjoutReparateur accident={accident} />} />
        </Routes>
    );
};

export default Sinistre;
